module.exports = __webpack_public_path__ + "img/graphics-4829280.ce785db.png";